export const FETCH_TRACKS_REQUEST = 'FETCH_TRACKS_REQUEST'
export const FETCH_TRACKS_SUCCESS = 'FETCH_TRACKS_SUCCESS'
export const FETCH_TRACKS_FAILED = 'FETCH_TRACKS_FAILED'

export const FETCH_UPDATE_TRACK_REQUEST = 'FETCH_UPDATE_TRACK_REQUEST'
export const FETCH_UPDATE_TRACK_SUCCESS = 'FETCH_UPDATE_TRACK_SUCCESS'
export const FETCH_UPDATE_TRACK_FAILED = 'FETCH_UPDATE_TRACK_FAILED'

export const FETCH_DELETE_TRACK_REQUEST = 'FETCH_DELETE_TRACK_REQUEST'
export const FETCH_DELETE_TRACK_SUCCESS = 'FETCH_DELETE_TRACK_SUCCESS'
export const FETCH_DELETE_TRACK_FAILED = 'FETCH_DELETE_TRACK_FAILED'

export const FETCH_CREATE_TRACK_REQUEST = 'FETCH_CREATE_TRACK_REQUEST'
export const FETCH_CREATE_TRACK_SUCCESS = 'FETCH_CREATE_TRACK_SUCCESS'
export const FETCH_CREATE_TRACK_FAILED = 'FETCH_CREATE_TRACK_FAILED'



// WEBPACK FOOTER //
// ./src/modules/Dashboard/consts/playerConsts.js